import React from "react";
import MasterDetailLayout from "../../../../components/layout/MasterDetailLayout";
import RefillCompactList from "../components/RefillCompactList";

const RefillSplitView = () => <MasterDetailLayout list={<RefillCompactList />} />;

export default RefillSplitView;
